export default {
  getChanged: state => state.changed,
  getLanguages: state => state.languages,
  getEducation: state => state.education,
  getExperiences: state => state.experiences,
  getSkills: state => state.skills,
  getCourses: state => state.courses,
  getLicences: state => state.licences,
  getHasCar: state => state.hasCar,
  getOther: state => state.other
}
